module.exports = __webpack_public_path__ + "img/blog-6.4ad8c369.webp";